/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Hero_BreadcrumbInputs */

const es_l7_hero_breadcrumb = /** @type {(inputs: L7_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armadores`)
};

const gl_l7_hero_breadcrumb = /** @type {(inputs: L7_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armadores`)
};

const en_l7_hero_breadcrumb = /** @type {(inputs: L7_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat owners`)
};

/**
* | output |
* | --- |
* | "Boat owners" |
*
* @param {L7_Hero_BreadcrumbInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_hero_breadcrumb = /** @type {((inputs?: L7_Hero_BreadcrumbInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Hero_BreadcrumbInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_hero_breadcrumb(inputs)
	if (locale === "en") return en_l7_hero_breadcrumb(inputs)
	return es_l7_hero_breadcrumb(inputs)
});